<template>
  <div
    v-if="menuDatas && permissionMenuList"
    class="main-header"
  >
    <template v-if="routeName === 'InqueryDetail' || routeName === 'ClueDetail'">
      <a-breadcrumb
        v-if="crumb"
        separator="/"
      >
        <a-breadcrumb-item v-if="parentName">
          {{ parentName }}
        </a-breadcrumb-item>
        <a-breadcrumb-item v-if="activeName">
          <a
            href="javascript:;"
            class="btn-text"
            @click="goBackList"
          >{{ activeName }}</a>
        </a-breadcrumb-item>
        <a-breadcrumb-item>
          [{{ code }}]
        </a-breadcrumb-item>
      </a-breadcrumb>
      <h1 class="title code">
        [{{ code }}]
      </h1>
      <slot />
    </template>
    <h1
      v-else
      class="title"
    >
      {{ activeName }}
    </h1>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getLang } from '@/lib/storage'

export default {
  name: 'MainTitle',
  props: {
    code: {
      type: String,
      default: ''
    },
    crumb: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState(['menuDatas']),
    from () {
      return this.$route.query.from || 'all'
    },
    type () {
      return this.$route.query.type || 'inquiry-all'
    },
    routeName () {
      return this.$route.name
    },
    enMenuData () {
      return {
        'inquiry-audit': {
          'state': true,
          'name': 'Recheck',
          'child': {
            'wait-audit': {
              'state': true,
              'name': 'Pending recheck'
            },
            'refused-audit': {
              'state': true,
              'name': 'Dismissed'
            }
          }
        },
        'inquiry-mine': {
          'state': true,
          'name': 'My inquiry',
          'child': {
            'inquiry-dev': {
              'state': true,
              'name': 'I developed'
            },
            'inquiry-add': {
              'state': true,
              'name': 'I recorded'
            },
            'inquiry-audit': {
              'state': true,
              'name': 'I  rechecked'
            },
            'inquiry-followup': {
              'state': true,
              'name': 'I followed'
            },
            'inquiry-share': {
              'state': true,
              'name': 'Shared'
            }
          }
        },
        'inquiry-all': {
          'state': true,
          'name': 'All',
          'child': {
            'inquiry-manager-all': {
              'state': true,
              'name': 'All inquiries'
            },
            'inquiry-manager-followup': {
              'state': true,
              'name': 'Following up'
            },
            'inquiry-manager-need-allocate': {
              'state': true,
              'name': 'To be assigned'
            },
            'inquiry-manager-need-assign': {
              'state': true,
              'name': 'To be designated'
            },
            'inquiry-manager-share': {
              'state': true,
              'name': 'Shared'
            },
            'inquiry-archive': {
              'state': true,
              'name': 'Archived'
            }
          }
        }
      }
    },
    permissionMenuList () {
      const { permissionMenuList = {} } = this.menuDatas
      return permissionMenuList
    },
    tabDatas () {
      let { permissionMenuList } = this
      let data = {}

      if (this.from === 'all') {
        data = permissionMenuList['inquiry-all']
      } else if (this.from === 'my') {
        data = permissionMenuList['inquiry-mine']
      } else if (this.from === 'audit') {
        data = permissionMenuList['inquiry-audit']
      }
      // 补充。。。
      return data
    },
    parentName () {
      const { name = '' } = this.tabDatas || {}
      return name || ''
    },
    activeName () {
      const { child = {} } = this.tabDatas || {}
      let name = child[this.type] && child[this.type].name

      if (this.from === 'checkrepeat') {
        name = this.$t('message["1355"]')
      }
      return name || ''
    }
  },
  methods: {
    getLang,
    goBackList () {
      let routeName
      if (this.from === 'audit') {
        routeName = 'InqueryAudit'
      } else if (this.from === 'my' || this.from === 'all') {
        routeName = 'InqueryList'
      } else if (this.from === 'checkrepeat') {
        routeName = 'InqueryRepeat'
      } else if (this.from === 'clue') {
        routeName = 'InqueryClue'
      }
      this.$router.push({
        name: routeName,
        query: {
          ...this.$route.query,
          type: this.type,
          from: this.from
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main-header {
  position: relative;

  h1.title.code {
    margin-top: 0;
  }
}
</style>
